module.exports = __webpack_public_path__ + "static/appdashboard-feffa01f7d01338821b55aff0d71276f.png";